import type { Step } from '@lemonade-hq/chat-engine';
import type { WizardExtendedStepWithPersistence } from '@lemonade-hq/chat-wizard-client-base';
import type { I18nContextValue } from '@lemonade-hq/nuiza';
import type { UniclientStepPresentation } from '@lemonade-hq/uniclient-chat';
import { redirect } from '@lemonade-hq/uniclient-chat';

interface ErrorPageParams {
  readonly urls: {
    readonly home: string;
  };
  readonly s: I18nContextValue['s'];
}

export function errorStepGeneral({
  s,
  urls,
}: ErrorPageParams): WizardExtendedStepWithPersistence<Step<UniclientStepPresentation, unknown>> {
  return {
    name: 'error-general',
    presentation: {
      frame: {
        title: s('chat.error.general.title'),
        action: redirect({ content: s('chat.error.general.action'), url: urls.home }),
      },
    },
  };
}
